
import EventBus from '@/helpers/EventBus'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'RequestCodeLink' })
export default class extends Vue {
  onclick() {
    EventBus.$emit('request-code-link-clicked')
  }
}
